'use client';

import { Card, Stack } from '@/ui/primatives';
import { Container } from '@/ui/PageLayout';
import { colors } from '@/styles';

const VersionUpdateAlert: React.FC<{}> = ({}) => {
  return (
    <Container>
      <Card.BorderFade borderWidth={2} shadow background={colors.secondary.lightGray1} style={{ padding: 15 }}>
        <Stack gap={10}>
          <h6>✋ We're updating this repository.</h6>
          <div>
            The herd is currently migrating Oxen to v0.19.0 which will improve performance and reliability. Come back in
            an hour or two to check if your repository has been migrated.
          </div>
        </Stack>
      </Card.BorderFade>
    </Container>
  );
};

export default VersionUpdateAlert;
